export default __webpack_public_path__ + "static/media/ratcatcher-ii.43892877.png";